import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function fetchUpdateConfiguration({
  partId,
  selectionPath,
  symbol,
  value,
}: {
  partId: string;
  selectionPath: string;
  symbol: string;
  value: string;
}) {
  const response = await occFetch(occUrl("/cad/updateConfig"), {
    body: JSON.stringify({ partId, selectionPath, symbol, value }),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  return response.json();
}
